import * as reportMethods from './reportApi';

export default {
  install(Vue) {
    Object.keys(reportMethods).forEach(key => {
      Vue.prototype[`$${key}`] = reportMethods[key];
    });
  }
};